import {CitySlug, OsmMapRegionParams} from "../../../../../config/cities";
import {IChartsMapParentRegion, IChartsSelectedRegion} from "../redux/map_city_poc_slice";
import {IOsmDistrictPolygon} from "../types/osm_district_polygon";
import {resolveMapRegionParamsFromSelection} from "./resolve_map_region_params_from_selection";

export function buildMapParentRegionSnapshot(params: {
    isRouteCity: boolean;
    regionId: number;
    slug: string;
    label: string;
    citySlug: CitySlug | null;
    hasChartsAccess: boolean;
    mapParams: OsmMapRegionParams;
}): IChartsMapParentRegion {
    return {
        isRouteCity: params.isRouteCity,
        regionId: params.regionId,
        slug: params.slug,
        label: params.label,
        citySlug: params.citySlug,
        hasChartsAccess: params.hasChartsAccess,
        regionsMapSlug: params.mapParams.regionsMapSlug,
        regionsMapParentId: params.mapParams.regionsMapParentId,
        regionsMapRegionId: params.mapParams.regionsMapRegionId,
        regionsMapChildType: params.mapParams.regionsMapChildType
    };
}

export function buildDistrictDrillDownSelection(
    district: IOsmDistrictPolygon,
    routeCitySlug: CitySlug,
    parent: IChartsMapParentRegion
): IChartsSelectedRegion {
    return {
        regionId: district.id,
        slug: district.slug,
        citySlug: routeCitySlug,
        label: district.full_name_reverted,
        hasChartsAccess: parent.hasChartsAccess,
        parentRegion: parent,
        ...resolveMapRegionParamsFromSelection({
            id: district.id,
            slug: district.slug,
            type: district.type
        })
    };
}

export function restoreParentRegionSelection(parent: IChartsMapParentRegion): IChartsSelectedRegion {
    return {
        regionId: parent.regionId,
        slug: parent.slug,
        citySlug: parent.citySlug,
        label: parent.label,
        hasChartsAccess: parent.hasChartsAccess,
        regionsMapSlug: parent.regionsMapSlug,
        regionsMapParentId: parent.regionsMapParentId,
        regionsMapRegionId: parent.regionsMapRegionId,
        regionsMapChildType: parent.regionsMapChildType
    };
}
